import { Button, Input, Form } from "antd";

export const AlumnoFields = ({ isRequired }) => {
    return (
        <>
            <Form.Item
                name="RTN"
                label="RTN"
                tooltip="Registro tributario nacional"
                rules={[{ required: isRequired }]}>
                <Input placeholder="Introduzca el número del RTN" />
            </Form.Item>
            <Form.Item
                name="Sell_to_Customer_Name_2"
                label="Alumno"
                rules={[{ required: isRequired }]}>
                <Input placeholder="Ingrese el nombre a quien se va a facturar" />
            </Form.Item>
            <Form.Item
                name="Bill_to_Address"
                label="Dirección de facturación"
                rules={[
                    {
                        required: isRequired,
                        message: "Ingrese una dirección de facturación",
                    },
                ]}
            >
                <Input />
            </Form.Item></>
    );
}

export const AlumnoForm = (props) => {
    const { handleSubmit, handleCancel, initialData, isRequired } = props;
    const [form] = Form.useForm();

    return (
        <Form
            form={form}
            name="alumno-form"
            onFinish={(values) => {
                handleSubmit({
                    ...initialData,
                    ...values,
                },);
            }}
            layout="vertical"
        >
            <AlumnoFields isRequired={isRequired} />
            <Form.Item>
                <div style={{ display: "flex", gap: "10px" }}>
                    <Button type="primary" htmlType="submit" block>
                        Aceptar
                    </Button>


                    <Button onClick={() => { handleCancel(form) }} block>
                        Cancelar
                    </Button>
                </div>
            </Form.Item>
        </Form>
    );
}